import { IToggle } from '@unleash/nextjs';
import { NextRouter } from 'next/router';

import { getSearchResults } from 'src/services/apiRequests/SearchService';
import {
  ActorInfo,
  Award,
  FamilyMember
} from 'src/services/responseTypes/celebsResponse';

import { globalUrlHelper } from '../common';
import { DynamicObject } from '../commonTypes';
import { HTTP_HEADER_KEYS } from '../constants/HttpMethodsConstants';
import { NOT_FOUND } from '../constants/RouterConstants';
import { FeatureFlagConstants } from '../constants/utilConstants';
import { isFeatureEnabled } from '../RemoteConfig';

// TabHeaderComponent:

export const switchTabDetailsHandler = (
  z5Strings: DynamicObject,
  activeTab: string,
  tabArray: Array<{ id: string; displayName: string }>,
  tabDetails: any,
  celebData: ActorInfo
) => {
  // adding the constants in the translation file.
  const {
    EDUCATION_DETAILS,
    NET_WORTH,
    PHYSICAL_DIMENSION,
    AWARDS,
    MOTHER,
    FATHER,
    SPOUSE,
    CHILDREN,
    MARITAL_STATUS,
    DATE_OF_BIRTH,
    BIRTH_PLACE,
    BACKGROUND,
    CAREER,
    TRIVIA,
    EDUCATION,
    HEIGHT,
    WEIGHT
  } = z5Strings;

  //Destructuring of details for each tab.
  const {
    family: {
      children,
      mother: { name: motherName },
      father: { name: fatherName },
      spouse: { name: spouseName },
      maritalStatus: { name: maritalStatus }
    },
    educationDetails: {
      dateOfBirth,
      birthPlace,
      background,
      career,
      trivia,
      education
    },
    netWorth: { netWorth },
    physicalDimension: { height, weight },
    awards
  } = celebData;

  let allChildren = '';
  children?.map((item: FamilyMember, index: number) => {
    if (index === 0) {
      allChildren = item.name;
    } else {
      allChildren = allChildren + ', ' + item.name;
    }
  });

  let allAwards = '';
  if (awards && awards.length > 0) {
    awards?.map((item: Award, index: number) => {
      if (item != null) {
        if (index === 0) {
          allAwards = item.name;
        } else {
          allAwards = allAwards + ', ' + item.name;
        }
      }
    });
  }

  const temp = [
    {
      tabname: tabArray[0].id,
      tabDetail: [
        {
          id: MOTHER,
          displayData: motherName
        },
        {
          id: FATHER,
          displayData: fatherName
        },
        {
          id: SPOUSE,
          displayData: spouseName
        },
        { id: CHILDREN, displayData: allChildren },
        {
          id: MARITAL_STATUS,
          displayData: maritalStatus
        }
      ]
    },
    {
      tabname: EDUCATION_DETAILS,
      tabDetail: [
        {
          id: DATE_OF_BIRTH,
          displayData: dateOfBirth
        },
        {
          id: BIRTH_PLACE,
          displayData: birthPlace
        },
        {
          id: BACKGROUND,
          displayData: background
        },
        {
          id: CAREER,
          displayData: career
        },
        {
          id: TRIVIA,
          displayData: trivia
        },
        {
          id: EDUCATION,
          displayData: education
        }
      ]
    },
    {
      tabname: NET_WORTH,
      tabDetail: [
        {
          id: NET_WORTH,
          displayData: netWorth
        }
      ]
    },
    {
      tabname: PHYSICAL_DIMENSION,
      tabDetail: [
        {
          id: HEIGHT,
          displayData: height
        },
        {
          id: WEIGHT,
          displayData: weight
        }
      ]
    },
    {
      tabname: AWARDS,
      tabDetail: [
        {
          id: AWARDS,
          displayData: allAwards
        }
      ]
    }
  ];

  switch (activeTab) {
    case tabArray[0].id:
      return tabDetails(temp[0].tabDetail);

    case tabArray[1].id:
      return tabDetails(temp[1].tabDetail);

    case tabArray[2].id:
      return tabDetails(temp[2].tabDetail);

    case tabArray[3].id:
      return tabDetails(temp[3].tabDetail);

    case tabArray[4].id:
      return tabDetails(temp[4].tabDetail);

    default:
      return null;
  }
};

//Banner Component:
export const handleRedirectToFilmography = (currentPath: string) => {
  if (!currentPath?.includes('/filmography')) {
    const filmographyPath = `${currentPath}/filmography`;
    window.location.href = filmographyPath;
  }
};

export const handleRedirectBack = (currentPath: string) => {
  const biographyPath = currentPath?.replace('/filmography', '');
  window.location.href = biographyPath;
};

//Filmography Component:
export const fetchCelebFilmographyData = async (
  xAccessToken: string | undefined,
  reqObject: any
) => {
  const headers = [HTTP_HEADER_KEYS.X_ACCESS_TOKEN];
  const reqObj = {
    query: reqObject.query,
    country: reqObject.country,
    limit: reqObject.limit,
    page: reqObject.page,
    filters: reqObject.filters,
    languages: reqObject.languages,
    translation: reqObject.translation
  };
  const response = await getSearchResults(reqObj, headers);
  if (response) {
    return response?.hybridSearchResults?.rails[0].contents;
  }
  return [];
};

export enum CelebRedirectStatus {
  NOT_FOUND = 'notfound',
  NEW_PAGE = 'samepage',
  OLD_PAGE = 'oldpage'
}

export const celebProfileFeatureFlag = (
  remoteConfig: IToggle[],
  celebrityDetails: ActorInfo,
  isFilmoPage = false
) => {
  const isCelebeProfileFlag = isFeatureEnabled(
    remoteConfig,
    FeatureFlagConstants.FEATURE_CELEB_PROFILE
  );

  if (isCelebeProfileFlag && celebrityDetails) {
    return CelebRedirectStatus.NEW_PAGE;
  }
  if (isCelebeProfileFlag && isFilmoPage && !celebrityDetails) {
    return CelebRedirectStatus.NEW_PAGE;
  }

  if (isCelebeProfileFlag && !celebrityDetails) {
    return CelebRedirectStatus.NOT_FOUND;
  }
  if (!isCelebeProfileFlag) {
    // window.location.href = `/movies/celeb/${celebName}`;
    return CelebRedirectStatus.OLD_PAGE;
  }
};

export const getCelebName = (celebrityName: string) => {
  const celebName = celebrityName
    .replace(/-/g, ' ') // Replace hyphens with spaces
    .replace(/[^a-zA-Z\s]/g, '') // Remove all characters except letters and spaces
    .replace(/\s+/g, ' ') // Replace multiple spaces with a single space
    .trim() // Remove leading and trailing spaces
    .replace(/\b\w/g, (match) => match.toUpperCase()); // Capitalize the first letter of each word
  return celebName;
};

export const redirectHandler = (
  status: CelebRedirectStatus,
  router: NextRouter,
  celebQuery: string
) => {
  switch (status) {
    case CelebRedirectStatus.NEW_PAGE:
      break;
    case CelebRedirectStatus.OLD_PAGE:
      window.location.href = globalUrlHelper(`/movies/celeb/${celebQuery}`);
      break;
    case CelebRedirectStatus.NOT_FOUND:
      router.push(NOT_FOUND);
      break;
    default:
      router.push(NOT_FOUND);
  }
};
